import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=57c74489&"
import script from "./ReviewCard.vue?vue&type=script&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DynamicImg: require('/opt/build/repo/storefront/components/legacy/global/dynamic-img.vue').default,ReviewStars: require('/opt/build/repo/storefront/components/molecules/Review/ReviewStars.vue').default,BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,Flag: require('/opt/build/repo/storefront/components/legacy/global/flag.vue').default,BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default})
